import { openBlock as t, createElementBlock as e, createStaticVNode as a } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, l = /* @__PURE__ */ a('<path fill="#D80027" d="M40 20c0 11.046-8.954 20-20 20S0 31.046 0 20L20 0c11.046 0 20 8.954 20 20Z"></path><path fill="#0052B4" d="M20 20V0C8.954 0 0 8.954 0 20h20Z"></path><path fill="#F0F0F0" d="m17.391 11.705-2.442 1.149 1.3 2.365-2.652-.507-.336 2.68-1.847-1.971-1.848 1.97-.336-2.68-2.652.508 1.3-2.365-2.442-1.15 2.442-1.148-1.3-2.366 2.652.508.336-2.68 1.848 1.971 1.847-1.97.336 2.679 2.652-.508-1.3 2.366 2.442 1.149Z"></path><path fill="#0052B4" d="M11.414 15.427a3.723 3.723 0 1 0 0-7.445 3.723 3.723 0 0 0 0 7.445Z"></path><path fill="#F0F0F0" d="M11.414 13.688a1.986 1.986 0 0 1-1.984-1.983c0-1.094.89-1.984 1.984-1.984 1.093 0 1.983.89 1.983 1.984 0 1.094-.89 1.983-1.983 1.983Z"></path>', 5), c = [
  l
];
function h(n, i) {
  return t(), e("svg", o, [...c]);
}
const d = { render: h };
export {
  d as default,
  h as render
};
